import { render, staticRenderFns } from "./TextTextCard.vue?vue&type=template&id=203fd71e&scoped=true"
import script from "./TextTextCard.vue?vue&type=script&lang=js"
export * from "./TextTextCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203fd71e",
  null
  
)

export default component.exports